<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات هتل"
        >
          <b-form
            ref="hotelform"
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2 form-size"
                md="6"
                offset-md="3"
              >
                <b-row>

                  <b-col
                    class="image"
                    cols="12"
                  >
                    <b-media class="mb-2">
                      <template #aside>
                        <b-avatar
                          ref="previewEl"
                          :src="Form.Image"
                          size="90px"
                          rounded
                          button
                          @click="$refs.refInputEl.click()"
                        />
                      </template>
                      <input
                        :ref="'refInputEl'"
                        type="file"
                        class="d-none"
                        name="Image"
                        @input="imageRenderer($event)"
                      >
                      <b-row>
                        <b-col md="12">
                          <b-form-group
                            label="عنوان"
                            label-for="Title"
                            class="mb-0"
                          >
                            <b-form-input
                              id="Title"
                              v-model="Form.Title"
                              name="Title"
                              autocomplete="off"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-media>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="Subtitle"
                      label-for="Subtitle"
                    >
                      <b-form-input
                        id="Subtitle"
                        v-model="Form.Subtitle"
                        name="Subtitle"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <!--                  <b-col md="12">-->
                  <!--                    <b-form-group-->
                  <!--                        label="پیوند یکتا"-->
                  <!--                        label-for="Slug"-->
                  <!--                    >-->
                  <!--                      <b-form-input-->
                  <!--                          id="Sort"-->
                  <!--                          v-model="Form.Slug"-->
                  <!--                          name="Slug"-->
                  <!--                          autocomplete="off"-->
                  <!--                          dir="ltr"-->
                  <!--                      />-->
                  <!--                    </b-form-group>-->
                  <!--                  </b-col>-->

                  <b-col md="4">
                    <b-form-group
                      label="وضعیت"
                      label-for="IsActive"
                    >
                      <v-select
                        v-model="Form.IsActive"
                        :options="enums('IsActive')"
                        dir="rtl"
                        label="text"
                        name="IsActive"
                        :clearable="false"
                        :reduce="x => x.value"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="ستاره"
                      label-for="Star"
                    >
                      <b-form-input
                        id="Star"
                        v-model="Form.Star"
                        name="Star"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="شهر"
                      label-for="CityId"
                    >
                      <z-city
                        v-model="Form.CityId"
                        :multiple="false"
                        :clearable="false"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group
                      label="امکانات هتل"
                      label-for="HotelAmenity"
                    >
                      <b-form-tags
                        v-model="HotelAmenity"

                        placeholder=""
                        add-button-text="افزودن"
                        add-button-variant="outline-primary"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group
                      label="توضیحات"
                      label-for="Description"
                    >
                      <z-quill-editor v-model="Form.Description" />
                    </b-form-group>

                  </b-col>

                  <z-seo v-model="Form" />

                  <b-col cols="12">
                    <div class="divider divider-solid">
                      <div
                        class="divider-text"
                        style="font-weight: 600;"
                      >
                        گالری
                      </div>
                    </div>
                  </b-col>
                  <div
                    v-for="(item, index) in Form.HotelGallery"
                    :key="item.Id"
                    class="px-1 mb-1"
                  >
                    <b-avatar
                      ref="previewEl"
                      :src="item.Url"
                      size="120px"
                      rounded
                      class="foodrecipes-image mt-1"
                    />
                    <b-form-group style="width: 120px;">
                      <b-form-input
                        v-model="item.Title"
                        autocomplete="off"
                        class="mt-1"
                        @click="showModal(item)"
                      />
                    </b-form-group>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      style=""
                      class="btn-icon video-remove"
                      @click="removeGallery(item)"
                    >
                      <feather-icon
                        icon="XIcon"
                        size="14"
                      />
                    </b-button>
                  </div>

                  <input
                    ref="refGalley"
                    type="file"
                    class="d-none"
                    accept="image/*"
                    @change="galleryRenderer($event)"
                  >

                  <div class="px-1 mb-1 mt-1">
                    <div
                      class="activity-upload-video"
                      @click="$refs.refGalley.click()"
                    >
                      <div class="activity-upload-video-icon">
                        <feather-icon
                          size="24"
                          icon="UploadIcon"
                        />
                      </div>
                    </div>
                  </div>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      v-if="isShowModal"
      v-model="isShowModal"
      ok-title="ذخیره"
      centered
      ok-only
      title="عنوان تصویر"
      :no-close-on-backdrop="true"
      size="sm"
      @ok="saveModal"
    >
      <b-row class="mt-1">
        <b-col md="12">
          <b-form-group>
            <b-form-input
              v-model="row.Title"
              autocomplete="off"
              autofocus
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

  </b-overlay>
</template>

<script>

import ZQuillEditor from '@/tools/quilleditor.vue'
import ZCity from '@/tools/city.vue'
import ZSeo from '@/tools/seo.vue'

export default {
  name: 'HotelDetails',
  components: { ZCity, ZQuillEditor, ZSeo },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Subtitle: null,
        Image: null,
        Description: null,
        IsActive: true,
        HotelGallery: [],
        HotelAmenity: [],
        Slug: null,
        MetaTitle: null,
        ImageAlt: null,
        MetaDescription: null,
        MetaKeywords: null,
        Star: 1,
      },
      GalleryFile: [],
      HotelAmenity: [],
      loading: false,
      galleryId: 100,
      isShowModal: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.hotel.add
      if (this.$route.params.id) {
        url = this.$api.hotel.update
      }

      const formData = new FormData(this.$refs.hotelform)
      formData.append('Id', this.Form.Id)
      formData.append('IsActive', this.Form.IsActive)

      if (this.Form.Video instanceof File) {
        formData.append('Video', this.Form.Video)
      }

      if (this.Form.Description) {
        formData.append('Description', this.Form.Description)
      }

      if (this.Form.CityId) {
        formData.append('CityId', this.Form.CityId)
      }

      this.HotelAmenity.forEach((item, index) => {
        formData.append(`HotelAmenity[${index}].Id`, index)
        formData.append(`HotelAmenity[${index}].Title`, item)
      })

      this.Form.HotelGallery.forEach((item, index) => {
        formData.append(`HotelGallery[${index}].Id`, item.Id)
        if (item.Title) {
          formData.append(`HotelGallery[${index}].Title`, item.Title)
        }

        formData.append(`HotelGallery[${index}].Sort`, index)
        if (this.GalleryFile.filter(x => x.Id == item.Id)[0]) {
          formData.append(`HotelGallery[${index}].Url`, this.GalleryFile.filter(x => x.Id == item.Id)[0].Url)
        }
      })

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    galleryRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.galleryId++

        this.Form.HotelGallery.push({ Url: fileReader.result, Id: this.galleryId })
        this.GalleryFile.push({ Url: event.target.files[0], Id: this.galleryId })
      }
    },
    removeGallery(item) {
      this.Form.HotelGallery = this.Form.HotelGallery.filter(x => x.Id !== item.Id)
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.hotel.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
          this.HotelAmenity = this.Form.HotelAmenity.map(x => x.Title)
        })
    },
    showModal(row) {
      this.isShowModal = true
      this.row = row
    },
    saveModal() {
      this.isShowModal = false
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
